<template>
  <detail-template :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-maybay-state
            v-if="hcFlowInstance"
            :state="hcFlowInstance.currentStateCode"
          />
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >
            Yêu cầu đặt phòng khách sạn
          </div>
          <div class="margin-top-10" v-if="!!requestUserDeptRole">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{
              requestUserDeptRole.deptName
            }}</span>
          </div>
          <div
            class="margin-top-10 padding-bottom-10 flex-row has-border__bottom"
            v-if="hcCaseHotel && requestUserDeptRole"
          >
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{
                requestUserDeptRole.fullName
              }}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">
                {{ hcCaseHotel.createTime | dateFormatter({ nullValue: "-" }) }}
              </span>
            </div>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="150px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin yêu cầu
                  </div>

                  <el-form-item label="Tên yêu cầu" prop="requestName">
                    <el-input
                      v-model="form.requestName"
                      placeholder="Tên yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="100"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Nội dung yêu cầu" prop="requestContent">
                    <el-input
                      type="textarea"
                      v-model="form.requestContent"
                      placeholder="Nội dung yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="500"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <hc-ks-upload-readonly
                    v-if="!!hcCaseHotel"
                    :hcCaseMasterId="caseMasterId"
                    :hcCaseFlightFileType="
                      HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH
                    "
                    :id="hcCaseHotel.id"
                  ></hc-ks-upload-readonly>

                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin cán bộ
                  </div>

                  <hc-ks-users-readonly
                    :hcCaseMasterId="caseMasterId"
                  ></hc-ks-users-readonly>

                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10 margin-top-10"
                  >
                    Thông tin lưu trú
                  </div>

                  <hc-ks-upload-readonly
                    v-if="!!hcCaseHotel"
                    :hcCaseMasterId="caseMasterId"
                    :hcCaseFlightFileType="
                      HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN
                    "
                    :id="hcCaseHotel.id"
                  ></hc-ks-upload-readonly>

                  <hc-ks-places-readonly
                    :hcCaseMasterId="caseMasterId"
                  ></hc-ks-places-readonly>

                  <el-form-item
                    label="Ghi chú"
                    prop="note"
                    class="margin-top-5"
                  >
                    <el-input
                      type="textarea"
                      v-model="form.note"
                      placeholder="Ghi chú"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="500"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </VuePerfectScrollbar>

      <div
        class="footer"
        v-if="
          isAbleToCapNhat || isAbleToHuy || isAbleToPheDuyet || isAbleToTuChoi
        "
      >
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToCapNhat"
              @click="update"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToPheDuyet"
              @click="approve"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Phê duyệt
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToTuChoi"
              @click="reject"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToHuy"
              @click="cancel"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Hủy
            </el-button>

            <!--            <el-button-->
            <!--              size="medium"-->
            <!--              class="addDocs color__white bg__blue btn-none__border"-->
            <!--              @click="exportReport"-->
            <!--            >-->
            <!--              <i class="font-size__small fas fa-pencil-alt"></i>-->
            <!--              &nbsp;Xuất excel-->
            <!--            </el-button>-->
          </div>
        </div>
      </div>

      <hc-ks-approve-dialog
        v-if="!!hcCaseHotel && isEnableDialogApprove"
        :isOpen="isOpenDialogApprove"
        :id="hcCaseHotel.id"
        @dialogClosed="isEnableDialogApprove = false"
        @closeDialog="isOpenDialogApprove = false"
        @approveSuccess="approveSuccess"
      />

      <hc-ks-update-dialog
        v-if="!!hcCaseHotel && isEnableDialogUpdate"
        :isOpen="isOpenDialogUpdate"
        :id="hcCaseHotel.id"
        @dialogClosed="isEnableDialogUpdate = false"
        @closeDialog="isOpenDialogUpdate = false"
        @updateSuccess="updateSuccess"
      />

      <hc-ks-reject-dialog
        v-if="!!hcCaseHotel && isEnableDialogReject"
        :isOpen="isOpenDialogReject"
        :id="hcCaseHotel.id"
        @dialogClosed="isEnableDialogReject = false"
        @closeDialog="isOpenDialogReject = false"
        @rejectSuccess="rejectSuccess"
      />

      <hc-ks-cancel-dialog
        v-if="!!hcCaseHotel && isEnableDialogCancel"
        :isOpen="isOpenDialogCancel"
        :id="hcCaseHotel.id"
        @dialogClosed="isEnableDialogCancel = false"
        @closeDialog="isOpenDialogCancel = false"
        @cancelSuccess="cancelSuccess"
      />
    </template>
  </detail-template>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import dateFormatter from "../../../filters/dateFormatter";
  import DetailTemplate from "../../common/detail";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import hcStateToStateService from "../../../services/hcStateToStateService";
  import goBackMixin from "../../../mixins/goBackMixin";
  import constants from "../../../constants";
  import h from "../../../services/h";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";
  // import utils from "../../../services/utils";
  import HcMaybayState from "../vemaybay/hc-maybay-state";
  import HcKsApproveDialog from "./hc-ks-approve-dialog";
  import HcKsCancelDialog from "./hc-ks-cancel-dialog";
  import HcKsPlacesReadonly from "./hc-ks-places-readonly";
  import HcKsRejectDialog from "./hc-ks-reject-dialog";
  import HcKsUpdateDialog from "./hc-ks-update-dialog";
  import HcKsUploadReadonly from "./hc-ks-upload-readonly";
  import HcKsUsersReadonly from "./hc-ks-users-readonly";

  export default {
    name: "hc-ks-detail",
    mixins: [handleRequestErrorMixin, goBackMixin],
    filters: {dateFormatter},
    components: {
      HcKsUpdateDialog,
      HcKsRejectDialog,
      HcKsApproveDialog,
      HcKsCancelDialog,
      HcKsPlacesReadonly,
      HcKsUsersReadonly,
      HcKsUploadReadonly,
      HcMaybayState,
      DetailTemplate,
      VuePerfectScrollbar
    },

    data() {
      return {
        hcCaseHotel: null,
        hcFlowInstance: null,
        hcCaseMaster: null,
        nextHcStateToStateActions: null,
        requestUserDeptRole: null,
        form: {
          requestName: null,
          requestContent: null,
          note: null
        },
        rules: {},

        isAbleToCapNhat: false,
        isAbleToHuy: false,
        isAbleToPheDuyet: false,
        isAbleToTuChoi: false,

        isOpenDialogApprove: false,
        isEnableDialogApprove: false,
        isOpenDialogReject: false,
        isEnableDialogReject: false,
        isOpenDialogCancel: false,
        isEnableDialogCancel: false,
        isOpenDialogUpdate: false,
        isEnableDialogUpdate: false,

        HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
        HC_STATE_TO_STATE: constants.HC_STATE_TO_STATE
      };
    },

    computed: {
      caseMasterId() {
        return this.$route.params.id;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    watch: {
      caseMasterId() {
        this.reloadPage();
      },

      isOpenDialogApprove(newValue) {
        if (newValue) this.isEnableDialogApprove = newValue;
      },

      isOpenDialogReject(newValue) {
        if (newValue) this.isEnableDialogReject = newValue;
      },

      isOpenDialogCancel(newValue) {
        if (newValue) this.isEnableDialogCancel = newValue;
      },

      isOpenDialogUpdate(newValue) {
        if (newValue) this.isEnableDialogUpdate = newValue;
      }
    },

    created() {
      this.initSelectOptions();
      this.initPage();
    },

    methods: {
      // exportReport() {
      //   let query = {
      //     userDeptRoleId: this.userDeptRoleId,
      //     hcCaseMasterId: this.caseMasterId
      //   };
      //   utils.exportReport(constants.REPORT.MAY_BAY.REPORT_URL, query);
      // },

      afterSubmitSuccess() {
        this.notifyMasterForDataChange({});
        this.goBack();
      },

      update() {
        this.isOpenDialogUpdate = true;
      },

      updateSuccess() {
        this.isOpenDialogUpdate = false;
        this.afterSubmitSuccess();
      },

      loadRequestUserDeptRole() {
        return userDeptRoleViewService
          .findRequesterForHc(this.caseMasterId)
          .then(response => (this.requestUserDeptRole = response.data));
      },

      cancel() {
        this.isOpenDialogCancel = true;
      },

      cancelSuccess() {
        this.isOpenDialogCancel = false;
        this.afterSubmitSuccess();
      },

      rejectSuccess() {
        this.isOpenDialogReject = false;
        this.afterSubmitSuccess();
      },

      reject() {
        this.isOpenDialogReject = true;
      },

      approve() {
        this.isOpenDialogApprove = true;
      },

      approveSuccess() {
        this.isOpenDialogApprove = false;
        this.afterSubmitSuccess();
      },

      async reloadPage() {
        await this.initPage();
      },

      initSelectOptions() {
      },

      async initPage() {
        await this.loadHcCaseHotel();
        await this.loadHcCaseMaster();
        await this.loadHcFlowInstance();
        await this.loadNextActions();
        await this.loadRequestUserDeptRole();
        this.initActions();
        this.initFormForEdit();
      },

      initFormForEdit() {
        this.bindDataToForm(this.form);
      },

      bindDataToForm(form) {
        form.requestName = this.hcCaseHotel.requestName;
        form.requestContent = this.hcCaseHotel.requestContent;
        form.note = this.hcCaseHotel.note;
      },

      initActions() {
        /**
         * -  Nếu yêu cầu ở trạng thái Chờ phê duyệt, người gửi yêu cầu và chuyên viên tổng hợp có thể chủ động cập nhật thông tin.
         -  Nếu yêu cầu ở trạng thái Đã phê duyệt thì chỉ người tổng hợp có quyền cập nhật thông tin, có thông báo tới người gửi yêu cầu
         */
        this.isAbleToCapNhat =
          this.isEnableAction(
            constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.CAP_NHAT
          ) &&
          ((this.hcFlowInstance.currentStateCode ===
            constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET &&
            (this.isApprover() || this.isRequester())) ||
            (this.hcFlowInstance.currentStateCode ===
              constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET &&
              this.isApprover()));

        this.isAbleToHuy = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.HUY
        );
        this.isAbleToPheDuyet = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.PHE_DUYET
        );
        this.isAbleToTuChoi = this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.TU_CHOI
        );
      },

      isApprover() {
        return (
          this.userDeptRole.roleCode ===
          constants.ROLE.CODE.KHACH_SAN.DUYET_KHACH_SAN
        );
      },

      isRequester() {
        return (
          this.userDeptRole.userId === this.hcCaseHotel.requestUserId &&
          this.userDeptRole.roleId === this.hcCaseHotel.requestRoleId &&
          this.userDeptRole.deptId === this.hcCaseHotel.requestDeptId
        );
      },

      isEnableAction(actionCode) {
        return h.exists(
          this.nextHcStateToStateActions,
          hcStateToState => hcStateToState.actionCode === actionCode
        );
      },

      loadNextActions() {
        return hcStateToStateService
          .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.nextHcStateToStateActions = response.data));
      },

      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseHotel.hcCaseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      loadHcCaseHotel() {
        return hcCaseHotelService
          .findByHcCaseMaster(this.caseMasterId)
          .then(response => (this.hcCaseHotel = response.data));
      },

      backListPage() {
        this.goBack();
      }
    }
  };
</script>

<style scoped>
  .error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    margin-left: 10px;
  }

  .tableHeader {
    height: 35px;
  }

  tr {
    text-align: center;
  }

  th {
    font-size: 13px;
    color: black;
    border-bottom: 1px solid #e3e8ee;
  }

  table {
    border: 1px solid #e3e8ee;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-detail.vue